import React from "react";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";

const useStyles = makeStyles((theme) => ({
  pagination: {
    "& > *": {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      width: "fit-content",
      margin: "auto",
    },
  },
}));

export default function SearchResultsPagination(props) {
  const classes = useStyles();
  const lastPageNumber = Math.ceil(props.results.totalItems / 10);
  return (
    <div className={classes.pagination}>
      <Pagination
        page={parseInt(props.pageNumber)}
        count={lastPageNumber}
        color="secondary"
        renderItem={(item) => {
          const lastItemNumber = lastPageNumber;
          if (item.page === lastItemNumber) {
            return null;
          } else {
            return (
              <PaginationItem
                component={Link}
                to={`/Search/${props.query}/${item.page}`}
                {...item}
              />
            );
          }
        }}
      />
    </div>
  );
}
